import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React, { useEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import { visuallyHidden } from '@mui/utils';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import { EmbersTableHead } from './tableHead/tableHead';
import { EmbersTableBody } from './tableBody/tableBody';
import { TableMessage } from './message/tableMessage';
import { StyledTableBaseWrapper } from './tableBaseStyles';
import { useWindowSize } from '../../utils/resizeHook';
import { ColumnMenu } from './tableHead/columnMenu/columnMenu';
import { EmbersTableLoading } from './tableLoading/tableLoading';
import { DEFAULT_WIDTH, getMinCellWidth, initializeCellWidth } from '../utils/resizeCellUtils';
export function EmbersTableBase(props) {
  var className = props.className,
    isDataSorted = props.isDataSorted,
    order = props.order,
    orderBy = props.orderBy,
    setOrderBy = props.setOrderBy,
    headCells = props.headCells,
    columnSelectionStorageKey = props.columnSelectionStorageKey,
    rows = props.rows,
    selected = props.selected,
    setSelected = props.setSelected,
    bodyCheckboxesLabels = props.bodyCheckboxesLabels,
    identifier = props.identifier,
    eyeColumn = props.eyeColumn,
    dataMapping = props.dataMapping,
    mappedKeys = props.mappedKeys,
    message = props.message,
    maxHeight = props.maxHeight,
    stickyHeader = props.stickyHeader,
    loading = props.loading,
    onRowClick = props.onRowClick,
    headerCheckboxDisabled = props.headerCheckboxDisabled,
    getRowCheckboxDisabled = props.getRowCheckboxDisabled,
    getExtraRowClasses = props.getExtraRowClasses,
    scrollContainerClass = props.scrollContainerClass,
    mixpanelProps = props.mixpanelProps,
    tableCollectionString = props.tableCollectionString,
    expandColumnId = props.expandColumnId,
    caption = props.caption,
    id = props.id,
    getRowDisabled = props.getRowDisabled,
    rowDisabledClassName = props.rowDisabledClassName;
  var containerRef = useRef(null);
  var focusRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasExtraWidth = _useState2[0],
    setHasExtraWidth = _useState2[1];
  // optionWidth is checkboxWidth + eyeColumnWidth
  var _useState3 = useState(headCells),
    _useState4 = _slicedToArray(_useState3, 2),
    defaultHeadCells = _useState4[0],
    setDefaultHeadCells = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    optionWidth = _useState6[0],
    setOptionWidth = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    tempHeadCells = _useState8[0],
    setTempHeadCells = _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    columnMenuAnchorEl = _useState10[0],
    setColumnMenuAnchorEl = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    headCheckboxChecked = _useState12[0],
    setHeadCheckboxChecked = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    headCheckboxDisabled = _useState14[0],
    setHeadCheckboxDisabled = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    defaultVisibleColumns = _useState16[0],
    setDefaultVisibleColumns = _useState16[1];
  var columnMenuOpen = Boolean(columnMenuAnchorEl);
  var size = useWindowSize();
  var getIdentifierArr = function getIdentifierArr() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return data.map(function (row) {
      return row[identifier];
    });
  };
  var _useState17 = useState([]),
    _useState18 = _slicedToArray(_useState17, 2),
    headCellIds = _useState18[0],
    setHeadCellIds = _useState18[1];
  var _useState19 = useState([]),
    _useState20 = _slicedToArray(_useState19, 2),
    visibleWeightHeadCells = _useState20[0],
    setVisibleWeightHeadCells = _useState20[1];
  useEffect(function () {
    var headCellIds = _toConsumableArray(headCells).map(function (item) {
      return item.id;
    });
    setHeadCellIds(headCellIds);
    var visibleWeightHeadCells = _toConsumableArray(headCells).sort(function (a, b) {
      var _b$visibleWeight, _a$visibleWeight;
      return ((_b$visibleWeight = b.visibleWeight) !== null && _b$visibleWeight !== void 0 ? _b$visibleWeight : 0) - ((_a$visibleWeight = a.visibleWeight) !== null && _a$visibleWeight !== void 0 ? _a$visibleWeight : 0);
    });
    setVisibleWeightHeadCells(visibleWeightHeadCells);
  }, [headCells]);
  useEffect(function () {
    if (selected) {
      var selectedIdentifierArr = getIdentifierArr(selected);
      var currentPageSelectedRows = rows.filter(function (row) {
        return selectedIdentifierArr === null || selectedIdentifierArr === void 0 ? void 0 : selectedIdentifierArr.includes(row[identifier]);
      });
      var currentPageAllowSelectRows = rows;
      if (getRowCheckboxDisabled) {
        currentPageAllowSelectRows = rows.filter(function (row) {
          var disabled = getRowCheckboxDisabled(row);
          return !disabled;
        });
      }
      setHeadCheckboxChecked(currentPageAllowSelectRows.length > 0 && currentPageSelectedRows.length === currentPageAllowSelectRows.length);
      setHeadCheckboxDisabled(headerCheckboxDisabled || currentPageAllowSelectRows.length === 0);
    }
  }, [rows, selected === null || selected === void 0 ? void 0 : selected.length]);
  var handleSelectAllClick = function handleSelectAllClick(event) {
    var _selected = selected || [];
    if (event.target.checked) {
      var selectedRows = rows;
      if (getRowCheckboxDisabled) {
        selectedRows = rows.filter(function (row) {
          var disabled = getRowCheckboxDisabled(row);
          return !disabled;
        });
      }
      setSelected === null || setSelected === void 0 || setSelected(Array.from(new Set([].concat(_toConsumableArray(_selected), _toConsumableArray(selectedRows)))));
    } else {
      var currentPageRowsIdentifierArr = getIdentifierArr(rows);
      setSelected === null || setSelected === void 0 || setSelected(_toConsumableArray(_selected.filter(function (select) {
        return !currentPageRowsIdentifierArr.includes(select[identifier]);
      })));
    }
  };
  var handleRequestSort = function handleRequestSort(event, property) {
    var _mixpanelProps$tracke, _mixpanelProps$tracke2;
    var direction = property !== orderBy ? 'desc' : order === 'asc' ? 'desc' : 'asc';
    mixpanelProps === null || mixpanelProps === void 0 || (_mixpanelProps$tracke = (_mixpanelProps$tracke2 = mixpanelProps.tracker).sortTable) === null || _mixpanelProps$tracke === void 0 || _mixpanelProps$tracke.call(_mixpanelProps$tracke2, mixpanelProps === null || mixpanelProps === void 0 ? void 0 : mixpanelProps.tableName, property, direction);
    setOrderBy && setOrderBy(property, direction);
  };
  var trackColumnEvent = function trackColumnEvent(selectedColumns) {
    if (selectedColumns.length > tempHeadCells.length) {
      var _mixpanelProps$tracke3, _mixpanelProps$tracke4;
      // show column event
      var _selected2 = selectedColumns.filter(function (id) {
        return !tempHeadCells.find(function (cell) {
          return cell.id === id.id;
        });
      });
      mixpanelProps === null || mixpanelProps === void 0 || (_mixpanelProps$tracke3 = (_mixpanelProps$tracke4 = mixpanelProps.tracker).showColumn) === null || _mixpanelProps$tracke3 === void 0 || _mixpanelProps$tracke3.call(_mixpanelProps$tracke4, mixpanelProps === null || mixpanelProps === void 0 ? void 0 : mixpanelProps.tableName, _selected2[0].id);
    } else if (selectedColumns.length < tempHeadCells.length) {
      var _mixpanelProps$tracke5, _mixpanelProps$tracke6;
      //hide column event
      var unselected = tempHeadCells.filter(function (id) {
        return !selectedColumns.find(function (cell) {
          return cell.id === id.id;
        });
      });
      mixpanelProps === null || mixpanelProps === void 0 || (_mixpanelProps$tracke5 = (_mixpanelProps$tracke6 = mixpanelProps.tracker).hideColumn) === null || _mixpanelProps$tracke5 === void 0 || _mixpanelProps$tracke5.call(_mixpanelProps$tracke6, mixpanelProps === null || mixpanelProps === void 0 ? void 0 : mixpanelProps.tableName, unselected[0].id);
    }
  };
  var calculateColumnWidth = function calculateColumnWidth(selectColumns, isColumnChange) {
    var _containerRef$current;
    var sum = 0,
      minSum = 0,
      freezeCellWidth = 0,
      freezeCellCount = 0;
    var containerWidth = ((_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.clientWidth) || 0;
    // calculate selected columns width
    var temp = headCells.filter(function (cell) {
      var isChosen = selectColumns.includes(cell.id);
      if (isChosen) {
        sum += cell.width || DEFAULT_WIDTH.minWidth;
        minSum += cell.minWidth || DEFAULT_WIDTH.minWidth;
        if (cell.freezeWidth) {
          freezeCellWidth += cell.minWidth || DEFAULT_WIDTH.minWidth;
          freezeCellCount += 1;
        }
      }
      return isChosen;
    });
    // mixpanel event
    isColumnChange && trackColumnEvent(temp);
    // adjust column when content exceeds container
    var contentExceed = sum + optionWidth > containerWidth;
    if (contentExceed) {
      var noFreezeCellAvgWidth = (containerWidth - optionWidth - freezeCellWidth) / (temp.length - freezeCellCount);
      var allCellAvgWidth = (containerWidth - optionWidth) / temp.length;
      var remainingWidth = containerWidth - optionWidth;
      setHasExtraWidth(remainingWidth > minSum);
      temp = temp.map(function (cell) {
        var cellWidth = cell.minWidth;
        if (remainingWidth < minSum) {
          if (noFreezeCellAvgWidth > 0) {
            cellWidth = cell.freezeWidth ? cell.minWidth : noFreezeCellAvgWidth;
          } else {
            cellWidth = allCellAvgWidth;
          }
        }
        return _objectSpread(_objectSpread({}, cell), {}, {
          width: cellWidth
        });
      });
    } else {
      setHasExtraWidth(true);
    }
    setTempHeadCells(temp);
  };
  useEffect(function () {
    if (columnSelectionStorageKey) {
      var _localStorage$getItem;
      // @ts-ignore
      setDefaultVisibleColumns(((_localStorage$getItem = localStorage.getItem(columnSelectionStorageKey)) === null || _localStorage$getItem === void 0 ? void 0 : _localStorage$getItem.split(',')) || []);
    }
  }, []);

  //init
  useEffect(function () {
    if (containerRef.current) {
      var opWidth = eyeColumn ? DEFAULT_WIDTH.eyeWidth : 0;
      if (props.selected) opWidth += DEFAULT_WIDTH.checkboxWidth;
      setOptionWidth(opWidth);
      var width = containerRef.current.clientWidth;
      if (defaultVisibleColumns.length) {
        calculateColumnWidth(defaultVisibleColumns);
      } else {
        // auto adjust column show/hide
        var temp = [];
        var sum = opWidth;
        for (var i = 0; i < visibleWeightHeadCells.length; i++) {
          var col = visibleWeightHeadCells[i];
          if (!col.hidden) {
            var w = col.width || DEFAULT_WIDTH.minWidth;
            if (sum + w < width) {
              sum += w;
              temp.push(col);
            } else {
              break;
            }
          }
        }
        //ensure at least one column display
        if (temp.length === 0 && visibleWeightHeadCells.length > 0) {
          temp.push(visibleWeightHeadCells[0]);
          sum += visibleWeightHeadCells[0].width || DEFAULT_WIDTH.minWidth;
        }
        temp.sort(function (a, b) {
          return headCellIds.indexOf(a.id) - headCellIds.indexOf(b.id);
        });
        setHasExtraWidth(sum < width);
        setTempHeadCells(temp);
      }
    }
  }, [containerRef.current, size[0], visibleWeightHeadCells.length]);

  //handle show/hide column
  var onColumnChange = function onColumnChange(ids) {
    calculateColumnWidth(ids, true);
    setVisibleWeightHeadCells(visibleWeightHeadCells.map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        hidden: !ids.includes(item.id)
      });
    }));
    if (columnSelectionStorageKey) {
      setDefaultVisibleColumns(ids);
      localStorage.setItem(columnSelectionStorageKey, ids.join(','));
    }
  };
  var handleColumnMenuButtonClick = function handleColumnMenuButtonClick(event) {
    setColumnMenuAnchorEl(event.currentTarget);
    if (event.currentTarget) {
      focusRef.current = event.currentTarget;
    }
  };
  var handleTableScrolled = function handleTableScrolled() {
    setColumnMenuAnchorEl(null);
  };
  var getTempHeadCellsWithExpand = function getTempHeadCellsWithExpand() {
    var _containerRef$current2;
    var containerWidth = ((_containerRef$current2 = containerRef.current) === null || _containerRef$current2 === void 0 ? void 0 : _containerRef$current2.clientWidth) || 0;
    /**
     * set the column that will expand width, default expand the first column.
     * set the column's width to 0 here, then it will be rendered to 'auto', which makes it expand.
     */
    if (tempHeadCells.length > 0 && hasExtraWidth) {
      var _tempHeadCells = _toConsumableArray(tempHeadCells);
      var _index = visibleWeightHeadCells ? _tempHeadCells.findIndex(function (c) {
        return c.id === expandColumnId;
      }) : 0;
      if (_index === -1) _index = 0;
      var cell = _objectSpread(_objectSpread({}, _tempHeadCells[_index]), {}, {
        width: 0
      });
      _tempHeadCells[_index] = cell;

      // if the initial width is 0 or no defined, should initialize the specific width for columns to ensure the resizing functionality
      // if width = 0, should be the remaining width except other columns with the fixed width
      return _tempHeadCells.map(function (v, i) {
        var getWidth = function getWidth() {
          return v.width === 0 ? containerWidth - optionWidth - _tempHeadCells.reduce(function (a, b) {
            return a + initializeCellWidth(b);
          }, 0) : initializeCellWidth(v);
        };
        var newWidth = getWidth();
        return _objectSpread(_objectSpread({}, v), {}, {
          width: newWidth,
          idleWidth: newWidth > getMinCellWidth(defaultHeadCells, v) ? newWidth - getMinCellWidth(defaultHeadCells, v) : 0
        });
      });
    }
    return tempHeadCells;
  };
  var onResizeEnd = function onResizeEnd(cells) {
    setTempHeadCells(cells);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledTableBaseWrapper, {
    className: classnames('EmbersTable-root')
  }, /*#__PURE__*/React.createElement(TableContainer, {
    sx: {
      maxHeight: maxHeight
    },
    className: "EmbersTableWrapper-root",
    ref: containerRef
  }, /*#__PURE__*/React.createElement(Table, {
    stickyHeader: stickyHeader,
    "aria-labelledby": "".concat(id, "-caption"),
    size: "medium",
    className: "EmbersTableBase-root".concat(className ? " ".concat(className) : '')
  }, !!caption && /*#__PURE__*/React.createElement("caption", {
    style: visuallyHidden,
    id: "".concat(id, "-caption")
  }, caption), /*#__PURE__*/React.createElement(EmbersTableHead, {
    id: "".concat(id, "-tableHead"),
    numSelected: selected ? selected.length : void 0,
    order: order,
    orderBy: !message ? orderBy : void 0,
    onSelectAllClick: handleSelectAllClick,
    onRequestSort: handleRequestSort,
    rowCount: rows.length,
    defaultHeadCells: defaultHeadCells,
    headCells: getTempHeadCellsWithExpand(),
    eyeColumn: eyeColumn,
    onEyeColumnClick: handleColumnMenuButtonClick,
    eyeColumnMenuIsOpen: columnMenuOpen,
    onTableScrolled: handleTableScrolled,
    unclickable: loading || !!message,
    checked: headCheckboxChecked,
    checkboxDisabled: headCheckboxDisabled,
    tableCollectionString: tableCollectionString,
    scrollContainerClass: scrollContainerClass,
    onResizeEnd: onResizeEnd
  }), !loading && !message && /*#__PURE__*/React.createElement(EmbersTableBody, {
    id: "".concat(id, "-tableBody"),
    isDataSorted: isDataSorted,
    order: order,
    orderBy: orderBy,
    page: 1,
    rowsPerPage: 25,
    rows: rows,
    selected: selected,
    setSelected: setSelected,
    bodyCheckboxesLabels: bodyCheckboxesLabels,
    identifier: identifier,
    headCells: tempHeadCells,
    eyeColumn: eyeColumn,
    dataMapping: dataMapping,
    mappedKeys: mappedKeys,
    onRowClick: onRowClick,
    getRowCheckboxDisabled: getRowCheckboxDisabled,
    getRowDisabled: getRowDisabled,
    rowDisabledClassName: rowDisabledClassName,
    getExtraRowClasses: getExtraRowClasses
  })), loading && /*#__PURE__*/React.createElement(EmbersTableLoading, null), /*#__PURE__*/React.createElement("div", {
    role: "status",
    "aria-live": "polite"
  }, !loading && !!message && /*#__PURE__*/React.createElement(TableMessage, message)))), /*#__PURE__*/React.createElement(ColumnMenu, {
    anchorEl: columnMenuAnchorEl,
    open: columnMenuOpen,
    onClose: function onClose() {
      focusRef.current.focus();
      focusRef.current = null;
      setColumnMenuAnchorEl(null);
    },
    onColumnChange: onColumnChange,
    items: headCells,
    selectedItems: tempHeadCells
  }));
}